import { render, staticRenderFns } from "./MProduct.vue?vue&type=template&id=5d1687e4&"
import script from "./MProduct.vue?vue&type=script&lang=js&"
export * from "./MProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports